import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { logout } from "../../../store/user/actions";
import { getNotifications } from "../../../store/notification/actions";
import { withRouter } from "react-router-dom";
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Progress,
} from "reactstrap";

const propTypes = {
  notif: PropTypes.bool,
  accnt: PropTypes.bool,
  tasks: PropTypes.bool,
  mssgs: PropTypes.bool,
};

const defaultProps = {
  notif: false,
  accnt: false,
  tasks: false,
  mssgs: false,
};

class HeaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
  }

  componentDidMount() {
    this.props.getNotifications();
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  renderNotifications() {
    return this.props.notifications.map((notification) => {
      return (
        <DropdownItem key={notification.id}>
          <div className="text-truncate text-dark">
            &#8226; {notification.message}
          </div>
        </DropdownItem>
      );
    });
  }

  dropNotif() {
    const { totalNotifications } = this.props;

    return (
      <Dropdown
        nav
        className="d-md-down-none fix"
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
      >
        <DropdownToggle nav className="nav-pill">
          <i className="icon-bell"></i>
          <Badge pill color="danger">
            {totalNotifications}
          </Badge>
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-lg" style={{ width: 400 }}>
          <DropdownItem header tag="div" className="text-center ">
            <strong>Tienes {totalNotifications} notificaciones</strong>
          </DropdownItem>
          {this.renderNotifications()}
        </DropdownMenu>
      </Dropdown>
    );
  }

  dropAccnt() {
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        {this.props.user.photoUrl != null ? (
          <DropdownToggle nav className="nav-pill avatar">
            <img
              src={this.props.user.photoUrl}
              className="img-avatar"
              alt="admin@bootstrapmaster.com"
            />
          </DropdownToggle>
        ) : (
          <DropdownToggle nav className="nav-pill">
            <i className="icon-user"></i>
          </DropdownToggle>
        )}
        <DropdownMenu right>
          <DropdownItem header tag="div" className="text-center">
            <strong>{this.props.user.email}</strong>
          </DropdownItem>
          <DropdownItem onClick={() => this.props.history.push("/contactanos")}>
            <i className="fa fa-question-circle-o"></i>Contáctanos
          </DropdownItem>
          <DropdownItem onClick={() => this.props.logout()}>
            <i className="fa fa-sign-out"></i>Cerrar Sesión
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    const { notif, accnt, tasks, mssgs, ...attributes } = this.props;
    return notif ? this.dropNotif() : accnt ? this.dropAccnt() : null;
  }
}

HeaderDropdown.propTypes = propTypes;
HeaderDropdown.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    user: state.user.user,
    notifications: state.notification.notificationList.notifications,
    totalNotifications: state.notification.notificationList.total,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      getNotifications,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HeaderDropdown));



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown/HeaderDropdown.js